// @ts-check
import React from "react"
import SelectAttribute from "../../SelectAttribute"
import AvailableActions from "../../../actions/AvailableActions"
import RenderRowAttribute from "../../RenderRowAttribute"

/**
 * @type {AttributeItem}
 */
export const selectPageAction = (attributeProps, renderedElementProps = {}) => (
    <RenderRowAttribute
        {...attributeProps}
        render={props => (
            <AvailableActions>
                {actions => {
                    return (
                        <SelectAttribute
                            {...props}
                            options={actions.map(property => ({
                                value: property.id,
                                label: property.name,
                            }))}
                            {...renderedElementProps}
                        />
                    )
                }}
            </AvailableActions>
        )}
    />
)



// WEBPACK FOOTER //
// ./src/features/editor/attributes/items/actions/pageActions.js